// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"spinnerContainer--7b4ac","loaderContainer":"loaderContainer--2a804"};